import JobMapGraphCardLegends from './JobMapGraphCardLegends';
export default JobMapGraphCardLegends;
